module.exports = __webpack_public_path__ + "img/logo_login.6b934ef5.png";